export default {
  header: {
    appName: 'Corteza',
    layoutSwitcherTitle: 'Panel layout',
    tabsSwitcherTitle: 'Select tab',
    user: {
      logout: 'Logout',
      settings: 'Settings',
    },
  },
  layout: {
    defaultTabTitle: 'Untitled',
  },
  app: {
    general: {
      availableApps: 'Available applications',
      openTab: 'open in Corteza One',
      openWindow: 'open in a new window',
      openTabs: 'List of open tabs:',
    },
    jitsi: {
      toStart: 'To start a video call select from existing messaging channels',
      join: 'Join',
      or: 'OR',
      createNewRoom: 'Create a new room',
      roomName: 'Room name',
      defaultRemoteDisplayName: 'Fellow Cortezer',
      defaultLocalDisplayName: 'Anonymous',
      create: 'Create',
    },
    googleMaps: {
      search: 'Search',
    },
  },
}
